// order of enums dictates display order of accept new terms
export enum ContractType {
  TermsOfService = 'terms_of_service',
  PrivacyPolicy = 'privacy_policy',
  MembershipTerms = 'subscription_terms',
}
